import React, { useRef, useState } from 'react';
import { View, Text, Pressable, Image, useWindowDimensions, Platform } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { FlatList } from "react-native";
import apis from '@api/api';
import PreviewModal from './PreviewModal';
import AnimatedLottieView from '@utils/lottieAnimation';
import { Title } from '@constants/Themed';
import styles from "@stylesheet"
import WebView from 'react-native-webview';
import Button from '@components/UI/Button/Button';

interface GetEmailTemplatesProps {
  callback?: (item: any) => void;
}

const GetEmailTemplates = ({ callback }: GetEmailTemplatesProps) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [uploadHtml, setUploadHtml] = useState(false);
  const { width, height } = useWindowDimensions();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['defaultEmailTemplates'], queryFn: async () => {
    return await apis.getDefaultEmailTemplates();
  }
  });

  const previewRef = useRef(null);

  const _handleSelect = (item) => {
    if (item === selectedItem) return setSelectedItem(null);
    setSelectedItem(item);
    previewRef.current?.openModal(item);
    if (!callback) return;
    callback?.(item);
  }

  const RenderItem = ({ item, index }) => {
    return (
      <Pressable
        style={{
          borderRadius: 10,
          minHeight: 200,
          marginBottom: 15,
          backgroundColor: item === selectedItem ? 'rgb(90,192,234)' : 'rgba(100,100,100,0.3)',
          overflow: 'hidden'
        }}
        onPress={() => _handleSelect(item)}
      >
        <View style={{ height: 150, width: '100%' }}>
          <WebView 
            scalesPageToFit 
            scrollEnabled={false} 
            pointerEvents="none"
            style={{ flex: 1, backgroundColor: 'transparent' }}
            source={{ html: item.content?.template || '<html><body><p>No preview available</p></body></html>' }}
            contentWidth={width * 0.8}
          />
        </View>
        <View style={{ padding: 10, backgroundColor: item === selectedItem ? 'rgb(90,192,234)' : 'rgba(50,50,50,0.5)' }}>
          <Text style={{ textAlign: "center", color: "white", fontWeight: '600' }}>{item.title}</Text>
        </View>
      </Pressable>
    )
  }

  return (
    <View style={{ flex: 1, maxHeight: 700 }}>
      <PreviewModal ref={previewRef} />
      {
        uploadHtml ?
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Text style={{ color: 'white' }}>Upload HTML (Coming soon)</Text>
          </View>
          :
          <>
            <Title style={{ color: "white", textAlign: "center", marginBottom: 10 }}>Start with a template?</Title>
            <View style={{ flex: 1, paddingHorizontal: 10 }}>
              {
                isLoading ?
                  <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <AnimatedLottieView
                      style={{ width: 100, height: 100 }}
                      source={require('@assets/animations/leaf_Loader.json')}
                      autoPlay
                      loop
                    />
                  </View>
                  :
                  <FlatList
                    showsVerticalScrollIndicator={false}
                    keyExtractor={item => item._id}
                    data={data || []}
                    renderItem={({ item, index }) => <RenderItem item={item} index={index} />}
                    contentContainerStyle={{ paddingBottom: 20 }}
                    ListEmptyComponent={
                      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', paddingTop: 50 }}>
                        <Text style={{ color: 'white', fontSize: 16 }}>No templates available</Text>
                      </View>
                    }
                  />
              }
            </View>
          </>
      }
      <Button
        customStyle={{ minHeight: 40, marginTop: 10 }}
        buttonText={"Upload your own"}
        onPress={() => setUploadHtml(true)}
      />
    </View>
  )
}
export default GetEmailTemplates;
